"use client";
import { useState, useEffect } from "react";
import { Button, Image as ImageAntd, Row, Col } from "antd";
import Image from "next/image";
import iconShare from "@/public/icon/icon-share.svg";
import ModalShare from "../share-social/modal-share";
import { getBlogRelated } from "@/src/app/api/blog/service";
import defaulThumbnail from "@/public/image/default-thumbnail.jpg";
import styles from "@/src/component/blog/blog-detail.module.scss";
import Link from "next/link";
import { useRef } from "react";
import { CloseOutlined, OrderedListOutlined } from "@ant-design/icons";

export default function DetailPageTool({ data }) {
  const [openModalShare, setOpenModalShare] = useState(false);
  const [isOpenBackTop, setIsOpenBackTop] = useState(false);
  const [dataRelated, setDataRelated] = useState();
  const [showList, setShowList] = useState(false);
  const [showBtnList, setShowBtnList] = useState(false);
  const [fadeBtnList, setFadeBtnList] = useState(false);

  const isMobile = typeof window !== "undefined" && window.innerWidth < 768;
  const ref = useRef(null);

  function timeout() {
    const timeoutFade = setTimeout(() => setFadeBtnList(true), 3000);
    return () => {
      clearTimeout(timeoutFade);
    };
  }
  const checkHeight = (height) => {
    const mainContentHeight =
      document.getElementsByClassName("mainContent")[0]?.offsetHeight;
    if (height > (isMobile ? 500 : 330) && height < mainContentHeight) {
      setShowBtnList(true);
      timeout();
    } else {
      setShowBtnList(false);
      setFadeBtnList(false);
      setShowList(false);
    }
  };
  if (typeof window !== "undefined") {
    const { pageYOffset } = window;
    () => checkHeight(pageYOffset);
  }
  useEffect(() => {
    function onClickHandler(e) {
      const ele = e.target;
      if (showList) {
        if (
          !ref.current?.contains(ele) ||
          (ref.current?.contains(ele) && ele instanceof HTMLAnchorElement)
        ) {
          setShowList(false);
        }
      }
    }
    document.addEventListener("click", onClickHandler);
    return () => {
      document.removeEventListener("click", onClickHandler);
    };
  }, [showList]);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const scroll = () => {
        const { scrollY } = window;
        checkHeight(scrollY);
      };
      document.addEventListener("scroll", scroll);
    }
  }, []);

  useEffect(() => {
    (async () => {
      const res = await getBlogRelated(data.id, data.category[0].slug, 3);
      setDataRelated(res?.data?.result || null);
    })();
  }, []);

  const handleScroll = () => {
    if (window.scrollY > 100) {
      setIsOpenBackTop(true);
    } else {
      setIsOpenBackTop(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    if (typeof window !== "undefined" && window.innerWidth >= 768) {
      handleScroll();
      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    }
  }, []);

  return (
    <div>
      {/* share */}
      <div className="wp-interaction">
        <div className="wpInteractSearch">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
            }}
            onClick={() => setOpenModalShare(true)}
          >
            <Button
              icon={<Image src={iconShare} className="icon" alt="Share icon" />}
            />
            <span style={{ marginTop: 5 }}>Chia Sẻ</span>
          </div>
        </div>
      </div>
      {/* ralate posts */}
      {dataRelated && (
        <div className={styles.wpBlogRelated}>
          <p className={styles.headTitle}> BÀI VIẾT LIÊN QUAN </p>
          <Row gutter={[16, 16]}>
            {dataRelated?.map((item) => (
              <Col
                className={styles.wpContentCard}
                xs={24}
                sm={12}
                md={12}
                lg={8}
                xl={8}
              >
                <Link href={"/blog/" + item.slug}>
                  <div className={styles.contentImage}>
                    <ImageAntd
                      src={item.thumb ? item.thumb : defaulThumbnail}
                      preview={false}
                      width={"100%"}
                    ></ImageAntd>
                  </div>
                  <div className={styles.postingDate}>
                    {new Date(item.date).toLocaleDateString("vi-VN", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                    })}
                  </div>
                  <div
                    className={styles.headerTitle}
                    dangerouslySetInnerHTML={{ __html: item.title }}
                  ></div>
                  <p
                    className={styles.wpMainDesc}
                    dangerouslySetInnerHTML={{ __html: item.desc }}
                  ></p>
                </Link>
              </Col>
            ))}
          </Row>
        </div>
      )}
      {/* back to top */}
      <button
        onClick={scrollToTop}
        className="back-to-top"
        style={{
          display: isOpenBackTop ? null : "none",
        }}
      >
        <svg
          width="19"
          height="22"
          viewBox="0 0 19 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.37373 9.70711C1.98321 10.0976 1.35004 10.0976 0.959519 9.70711C0.568995 9.31658 0.568995 8.68342 0.959519 8.29289L2.37373 9.70711ZM9.66663 1L8.95952 0.292893C9.35004 -0.0976308 9.98321 -0.0976307 10.3737 0.292894L9.66663 1ZM18.3737 8.29289C18.7643 8.68342 18.7643 9.31658 18.3737 9.70711C17.9832 10.0976 17.35 10.0976 16.9595 9.70711L18.3737 8.29289ZM10.6666 21C10.6666 21.5523 10.2189 22 9.66663 22C9.11434 22 8.66663 21.5523 8.66663 21L10.6666 21ZM0.959519 8.29289L8.95952 0.292893L10.3737 1.70711L2.37373 9.70711L0.959519 8.29289ZM10.3737 0.292894L18.3737 8.29289L16.9595 9.70711L8.95952 1.70711L10.3737 0.292894ZM10.6666 1L10.6666 21L8.66663 21L8.66663 1L10.6666 1Z"
            fill="#222222"
          ></path>
        </svg>
      </button>
      {/* modal share */}
      <ModalShare openModal={openModalShare} setOpenModal={setOpenModalShare} />
      {/* toc */}
      {!showList && showBtnList && data.category[0].slug != "khuyen-mai" && (
        <>
          <div
            onClick={() => {
              setShowList(true);
            }}
            className={`${styles.pinContentList} ${
              fadeBtnList ? styles.fadePinContentList : ""
            }`}
          >
            <OrderedListOutlined />
          </div>
        </>
      )}
      {data?.category && data?.category[0]?.slug != "khuyen-mai" && (
        <div className={`${styles.tableOfContents} table-of-contents`}>
          <div
            className={`${styles.fixedContentList} ${
              showList ? styles.show : styles.hide
            }`}
            ref={ref}
          >
            <div className={styles.fixedContentListHeader}>
              <div className={styles.blockLeft}>
                <OrderedListOutlined />
                <span style={{ marginLeft: 6 }}>MỤC LỤC</span>
              </div>
              <div
                className={styles.blockRight}
                onClick={() => {
                  setShowList(false);
                  setFadeBtnList(false);
                  timeout();
                }}
              >
                <CloseOutlined />
              </div>
            </div>
            <div
              className={styles.tableOfContentsList}
              dangerouslySetInnerHTML={{
                __html: data?.tableOfContents,
              }}
            ></div>
          </div>
        </div>
      )}
    </div>
  );
}
